import type { IconProps } from './../../models/icon';

export function TimerIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.1541 0.857178 12 0.857178C5.846 0.857178 0.857178 5.846 0.857178 12C0.857178 18.1541 5.846 23.1429 12 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 0.857178C14.2039 0.857178 16.3582 1.51069 18.1907 2.73509C20.0231 3.95949 21.4514 5.69976 22.2947 7.73585C23.1381 9.77194 23.3587 12.0124 22.9288 14.1739C22.4988 16.3354 21.4375 18.321 19.8792 19.8792C18.321 21.4375 16.3354 22.4988 14.1739 22.9288C12.0124 23.3587 9.77194 23.1381 7.73585 22.2947C5.69976 21.4512 3.95949 20.0231 2.73509 18.1907C1.5107 16.3582 0.857185 14.2039 0.857185 12C0.853654 8.80798 2.0818 5.73765 4.28575 3.42861"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.857178 4.28561L4.28575 3.42847L5.14289 6.85704"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 6V12.8571L16.4571 15.0857"
        />
      </g>
    </svg>
  );
}
